import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import { Space, Button, Form, Alert, Radio, Divider, Row, Col, Tooltip, Upload, Input, Modal, Collapse } from "antd";
import { UploadOutlined } from '@ant-design/icons';
import * as Yup from 'yup';

import * as constants from '../constants';
import {
    setSelectedDetailIncidentIsDirty,
    getLinkedFile
} from '../actions';

import uistate from '../../uistate';
import globalappstate from '../../globalappstate';
import common from '../../../common';
import core from '../../core';
import dossier from '../../dossier';

const { SelectInput, TextInput, TextArea, CheckboxInput, DatePickerInput, TextInputSelect, NumberInput, PdfViewer, DisplayFormikState, FormDirtyTracker } = core;
const { DossierFilesGrid } = dossier
const ButtonGroup = Button.Group;
const FormItem = Form.Item;
const { Panel } = Collapse;

const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 15 },
}

const tailFormItemLayout = {
    wrapperCol: {
        xs: {
            span: 24,
            offset: 0,
        },
        sm: {
            span: 14,
            offset: 4,
        },
    },
};


class IncidentForm extends Component {

    state = {
        showViewer: false,
        imageloaded: false,
        url: '',
        filename: '',
        type: '',
        fileList: [],
        fileError: '',
    }

    async UNSAFE_componentWillMount() {
        if (this.props.datacontext.idLinkedIncidentFile) {
            let linkedfile = await this.props.getLinkedFile(this.props.datacontext.idLinkedIncidentFile);
            this.setState({
                fileList: [{
                    uid: linkedfile.idLinkedIncidentFile,
                    name: linkedfile.filename,
                    status: 'done',
                    url: linkedfile.url
                }],
                url: linkedfile.url,
                filename: linkedfile.filename,
                fileid: linkedfile.idLinkedIncidentFile,
                type: linkedfile.contenttype,
                imageloaded: true,
                filechanged: false,
            })
        }
    }

    onCancel = async () => {
        this.formik.resetForm();
        if (this.props.datacontext.idLinkedIncidentFile) {
            let linkedfile = await this.props.getLinkedFile(this.props.datacontext.idLinkedIncidentFile);
            this.setState({
                fileList: [{
                    uid: linkedfile.idLinkedIncidentFile,
                    name: linkedfile.filename,
                    status: 'done',
                    url: linkedfile.url
                }],
                url: linkedfile.url,
                filename: linkedfile.filename,
                fileid: linkedfile.idLinkedIncidentFile,
                type: linkedfile.contenttype,
                imageloaded: true,
                filechanged: false,
            })
        }
    }

    onSave = async (values, { setSubmitting, setErrors }) => {
        if (this.props.onSave) {
            try {
                if (this.state.filechanged) {
                    await this.props.onSavePlusFile(values, this.state.fileList[0])
                } else {
                    await this.props.onSave(values);
                }

                setSubmitting(false);
            } catch (error) {
                setSubmitting(false);
                setErrors();
            }
        } else {
            setSubmitting(false)
        }
    }
    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'IncidentForm', key);
    }

    FormSchema = () => {
        let schema = Yup.object().shape({
            subject: Yup.string().required('*'),
            date: Yup.date().required('*'),
            email: Yup.string().email(this.label('NoValidEmail')),
            idIncidentType: Yup.number().integer().required('*'),
        })

        return schema;
    }

    setSelectedDetailIncidentIsDirty = (dirty) => {
        this.props.setSelectedDetailIncidentIsDirty(dirty);
    }

    CreateForm = (props) => {

        const firstFormPart = <>
            <SelectInput {...props} name="idIncidentStatus" nameField="name" idField="id" items={this.props.picklists.incidentStatuses} label={this.label("Status")} formItemLayout={formItemLayout} />
            <TextInput {...props} name="subject" label={this.label("Subject")} formItemLayout={formItemLayout} />
            <TextInput {...props} name="phone" label={this.label("Phone")} formItemLayout={formItemLayout} />
            <TextInput {...props} name="email" label={this.label("Email")} formItemLayout={formItemLayout} />
            <DatePickerInput {...props} name="date" showTime={false} label={this.label("Date")} formItemLayout={formItemLayout} />
            <SelectInput {...props} name="idIncidentType" nameField="name" idField="id" items={this.props.picklists.incidentTypes} label={this.label("IncidentType")} formItemLayout={formItemLayout} />

            <TextArea {...props} name="description" label={this.label("Description")} rows={5} formItemLayout={formItemLayout} />
            <TextArea {...props} name="summary" label={this.label("Summary")} rows={3} formItemLayout={formItemLayout} />
            <SelectInput {...props} name="idCompany" nameField="name" idField="id" items={this.props.picklists.allCompanies} label={this.label("Company")} formItemLayout={formItemLayout} />

        </>
        const secondFormPart = <><Form.Item label={this.label("File")} labelCol={{ span: 4 }} wrapperCol={{ span: 10 }} hasFeedback={this.state.fileList.length < 1} validateStatus={this.state.fileError} >
            <Upload disabled={true} fileList={this.state.fileList} >
                <Button disabled={true}>
                    <UploadOutlined /> {this.label("SelectFile")}
                </Button>
            </Upload>
        </Form.Item>
        </>


        return (
            <Form layout='horizontal' style={{ margin: 10, maxHeight: this.props.contentheight - 10, overflowY: 'auto', overflowX: 'hidden' }}>
                <Row>
                    <Col span={16}>
                        {firstFormPart}
                    </Col>
                    <Col span={8}>
                        {secondFormPart}
                    </Col>
                </Row>
                <Row>
                    <Col span={18} offset={4} >
                        <h3>{this.label("Files")}</h3>
                        <DossierFilesGrid dossiertype={common.DOSSIER_TYPES.Incident} idDossier={props.values.idDossier} />
                    </Col>
                </Row>
                <Divider />
                <FormItem {...tailFormItemLayout} >
                    <ButtonGroup>
                        <Button size='small' type="primary" onClick={() => props.handleSubmit()} disabled={props.isSubmitting || this.props.readOnly} > {this.label("Save")} </Button>
                        <Button size='small' disabled={props.isSubmitting || this.props.readOnly} onClick={this.onCancel}>{this.label("Cancel")} </Button>
                    </ButtonGroup>
                    {props.isSubmitting &&
                        <Alert
                            message={this.label("Saving")}
                            style={{ marginTop: 20 }}
                        />
                    }
                </FormItem>
                {/* <DisplayFormikState {...props} /> */}
            </Form>
        )
    }

    render() {
        return (
            <Formik enableReinitialize={true} validateOnBlur={false} validateOnChange={false}
                initialValues={this.props.datacontext}
                validationSchema={this.FormSchema()}
                onSubmit={this.onSave}
                innerRef={p => (this.formik = p)}
            >
                {(props) => <><FormDirtyTracker dirty={props.dirty} onDirtyChange={this.setSelectedDetailIncidentIsDirty} />{this.CreateForm(props)}</>}
            </Formik>
        );
    }
}
function mapStateToProps(state) {
    return {
        picklists: globalappstate.selectors.allPicklists(state),
        labels: uistate.selectors.uiLabels(state),
    };
}


export default connect(mapStateToProps, {
    setSelectedDetailIncidentIsDirty,
    getLinkedFile
})(IncidentForm);


